"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showRakusenCardman = void 0;
exports.RakusenCardman = RakusenCardman;
var jsx_runtime_1 = require("react/jsx-runtime");
var containerStyle = { textAlign: "center" };
var textStyle = { color: "#999", fontSize: "smaller" };
var imageStyle = { maxWidth: "100%", maxHeight: "114px", border: "1px solid #999" };
exports.showRakusenCardman = new Date() >= new Date(2019, 11 - 1, 23, 0, 0, 0) && new Date() < new Date(2019, 12 - 1, 9, 0, 0, 0);
function RakusenCardman() {
    return ((0, jsx_runtime_1.jsxs)("div", { style: containerStyle, children: [(0, jsx_runtime_1.jsx)("div", { style: textStyle, children: "\u5E83\u544A" }), (0, jsx_runtime_1.jsx)("a", { href: "https://twitter.com/IspVitamin/status/1177478611638423554", target: "_blank", rel: "noopener noreferrer", children: (0, jsx_runtime_1.jsx)("img", { src: "./virtual_steel_museum_2.png", style: imageStyle }) })] }));
}
